import { EXPRESS_API } from 'configs/api/expressApi';
import { useInfiniteQuery } from 'react-query';
import { superAdminKeys } from './superAdminKeys';
import { errorToast } from 'lib/components/toasts/error';

export interface IResellersWithCustomersParams {
  limit: number;
  start: number;
}

export interface IResellersWithCustomers {
  resellerId: number;
  resellerName: string;
  customerCount: string;
}

export interface IResellersWithCustomersResponse {
  count: number;
  data: IResellersWithCustomers[];
}

const getResellersWithCustomerCounts = async (
  params: IResellersWithCustomersParams
): Promise<IResellersWithCustomersResponse> => {
  return (
    await EXPRESS_API.get(`/superadmin/resellers/customer-count`, {
      params,
    })
  ).data;
};

export const useGetResellersWithCustomerCounts = (
  params: IResellersWithCustomersParams,
  enabled: boolean = true
) => {
  return useInfiniteQuery(
    superAdminKeys.reseller_customer_counts(params),
    () => getResellersWithCustomerCounts(params),
    {
      refetchOnMount: true,
      staleTime: 0,
      enabled,
      onError: () => {
        errorToast({
          title:
            "We're currently experiencing difficulties fetching resellers.",
        });
      },
    }
  );
};
